import { render, staticRenderFns } from "./ResultMaterialsComputationNav.vue?vue&type=template&id=471b1470&"
import script from "./ResultMaterialsComputationNav.vue?vue&type=script&lang=js&"
export * from "./ResultMaterialsComputationNav.vue?vue&type=script&lang=js&"
import style0 from "./ResultMaterialsComputationNav.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports